<template lang="pug">
.container.room-details
  .room-grid
    .no(@click='goto_room(room.no)') {{room.no}}
    table.ui.very.basic.unstackable.compact.collapsing.table.info
      tbody
        tr
          td 状态
          td.hide-in-mobile(v-if='room.category') 楼层
          td.hide-in-mobile(v-if='room._type') 户型
          td 月租价格
          td(v-if='room.price_day') 日租价格
          td

        tr
          td
            .ui.label(:class='$formatters.state_class(state)') {{$formatters.state_label(state)}}
          td.hide-in-mobile(v-if='room.category') {{room.category}}
          td.hide-in-mobile(v-if='room._type') {{room._type.name}}
          td {{room.price_month}}
          td(v-if='room.price_day') {{room.price_day}}
          td
            template(v-if='available_preorders && available_preorders.length')
              el-popover(ref='preorders', placement='bottom', width='500', trigger='hover')
                h3 预订单
                auto-table(:defines='$defines.preorder', :data='available_preorders', unstackable, :detail-view='true', actions='order', @action:order='goto_preorder')

            el-popover(ref='properties', placement='bottom', width='650', trigger='hover')
              .with-actions
                h3 物品清单
                .ui.tiny.buttons.actions
                  .ui.basic.button.icon(@click='print_properties')
                    i.print.icon.themed.text
              room-properties(:properties='room.properties', :pagesize='15', :compact='true')

            el-popover(ref='utilities', placement='bottom', width='600', trigger='hover')
              .with-actions
                h3 水电表
                .ui.tiny.buttons.actions
                  .ui.basic.button.icon(@click='goto_utilities')
                    i.pencil.icon.themed.text
              utility-view(v-for='(utility, index) in room.utilities', :paid='room.utilities_paid' :key='index', :data='utility')

            el-popover(ref='history_notes', placement='bottom', width='600', trigger='hover')
              h3 房屋记录
              auto-table(:defines='$defines.history_notes', :data='room.history_notes || []')

            .ui.buttons
              template(v-if='available_preorders && available_preorders.length')
                .ui.icon.small.basic.button(v-if='$media.isMobile', @click='goto_overview')
                  i.icon.pin.themed.text
                  span.themed.text {{available_preorders.length}}
                .ui.icon.small.basic.button(v-else, v-popover:preorders='', @click='goto_overview')
                  i.icon.pin.themed.text
                  span.themed.text {{available_preorders.length}}
              template(v-else)
                .ui.icon.small.basic.button(data-tooltip='预定房间', data-position='top center', data-inverted='', @click='goto_new_preorder')
                  i.icon.pin

              .ui.icon.small.basic.button(data-tooltip='全部合同', data-position='top center', data-inverted='', @click='goto_overview')
                i.icon.archive
              .ui.icon.small.basic.button(data-tooltip='当前合同', data-position='top center', data-inverted='', @click='goto_current_contract', v-if='current_contract')
                i.icon.file
              .ui.icon.small.basic.button.hide-in-mobile(@click='goto_room_edit(room.no)', v-popover:properties='')
                i.icon.cubes
                span {{(room.properties || []).length}}

              .ui.icon.small.basic.button(@click='goto_utilities', v-if='$media.isMobile')
                i.icon.lightning
              .ui.icon.small.basic.button(@click='goto_utilities', v-else, v-popover:utilities='')
                i.icon.lightning

              .ui.icon.small.basic.button.hide-in-mobile(v-popover:history_notes='', @click='goto_room_edit(room.no)')
                i.icon.sticky.note
              .ui.icon.small.basic.button.hide-in-mobile(data-tooltip='修改房间信息', data-position='top center', data-inverted='', @click='goto_room_edit(room.no)')
                i.icon.pencil


  // Tracking note
  template(v-if='(room.tracking_notes || []).length')
    el-collapse(:value='1')
      el-collapse-item(:title='`待处理 (${pending_notes.length})`' v-if='pending_notes.length' :name='1')
        notes-list(:notes='pending_notes', @open='dialog_tracking_notes=true')
      el-collapse-item(:title='`已处理 (${checked_notes.length})`' v-if='checked_notes.length' :name='2')
        notes-list(:notes='checked_notes', @open='dialog_tracking_notes=true')

    dialog-tracking-notes(:visible.sync='dialog_tracking_notes', :room='room')

  // Lezhu Meter
  template(v-if='$config.logic.lezhu_meter && room.lezhu_meter_id')
    lezhu-monitor(:room='room')

  router-view
</template>

<script>
import { AutoTable, AutoEditTable } from '../components/auto'
import { UtilityView, NotesList } from '../components/basic'
import { DialogTrackingNotes } from '../components/forms'
import { RoomProperties, LezhuMonitor } from '../components/mixed'

export default {
  name: 'room',
  props: ['no'],
  components: {
    AutoEditTable,
    AutoTable,
    DialogTrackingNotes,
    RoomProperties,
    NotesList,
    UtilityView,
    LezhuMonitor,
  },
  computed: {
    room() {
      return this.$store.getters.room(this.no)
    },
    state() {
      return this.$store.getters.room_state(this.no)
    },
    available_preorders() {
      return this.$store.getters.preorders_of_room(this.room.no)
    },
    current_contract() {
      return this.$store.getters.current_contract_of_room(this.room.no)
    },
    pending_notes() {
      return this.room.tracking_notes.filter(i => !i.state)
    },
    checked_notes() {
      return this.room.tracking_notes.filter(i => i.state)
    },
  },
  data() {
    return {
      dialog_tracking_notes: false,
    }
  },
  watch: {
    $route() { this.changed() },
  },
  mounted() {
    this.changed()
  },
  methods: {
    changed() {
      if (!this.room)
        this.$router.replace('/404')
      else if (!this.$route.meta.title)
        this.$doc.title = this.no
    },
    print_properties() {
      this.$templater.request('properties', {
        room: this.room,
        properties: this.$store.getters.properties_of_room(this.room.properties),
      })
    },
    goto_room_edit() {
      this.$router.push(`/room/${this.room.no}/edit`)
    },
    goto_overview() {
      this.$router.push(`/room/${this.room.no}`)
    },
    goto_preorder(preorder) {
      this.$router.push(`/room/${this.room.no}/sign/by/${preorder._id}`)
    },
    goto_new_preorder() {
      this.$router.push(`/room/${this.room.no}/preorder`)
    },
    goto_utilities() {
      this.$router.push(`/room/${this.room.no}/utilities`)
    },
    goto_current_contract() {
      if (this.current_contract)
        this.$router.push(`/room/${this.room.no}/contract/${this.current_contract._id}`)
    },
  },
}
</script>



// WEBPACK FOOTER //
// Room.vue?26c73f40